const config = {
  // graphql: 'http://192.168.1.250:8001/',
  // wsGraphql: 'ws://192.168.1.250:8001/',
  graphql: "https://api.luminous.games/",
  wsGraphql: "wss://api.luminous.games/",
};
// const config = process.env.NODE_ENV === 'development' ? configDev : configDev
export { config };
